import { render, staticRenderFns } from "./FanFollowList.vue?vue&type=template&id=50712c06&scoped=true"
import script from "./FanFollowList.vue?vue&type=script&lang=js"
export * from "./FanFollowList.vue?vue&type=script&lang=js"
import style0 from "./FanFollowList.vue?vue&type=style&index=0&id=50712c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50712c06",
  null
  
)

export default component.exports